'use strict';

var EditWebFilters = require('actionGroups/webFilters/WebFilters');

module.exports = {
  Model: EditWebFilters,
};
